// LP最下部のエリアリンク集アコーディオン。中身は最初からHTMLにあり、開閉は
// クラスの付け外しだけ。リンクをJSで挿入しないのはクローラに辿らせるため。
document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".area-accordion__question");

  questions.forEach((question) => {
    question.addEventListener("click", function () {
      const item = this.parentElement;
      const opened = item.classList.toggle("is-open");
      this.setAttribute("aria-expanded", opened ? "true" : "false");
    });
  });
});
